import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class PlayerService {

  url = '/api/Player';

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  getFormTypes() {
    return this.httpService.get(`${this.url}/form-types`);
  }

  deleteForms(userID: number, playerFormIDs: number[]) {
    return this.httpService.delete(`${this.url}/forms/${userID}/${playerFormIDs.join(',')}`);
  }

  addForm(userID: number, data: any) {
    return this.httpService.post(`${this.url}/forms/${userID}`, data);
  }

  editForm(formData: any) {
    return this.httpService.post(`${this.url}/edit-player-from-title-and-type`, formData);
  }

  updateSafeSportCertificate(formData: any) {
    return this.httpService.post(`${this.url}/update-safeSport-certificate`, formData);
  }

  getUserRoles() {
    return this.httpService.get(`${this.url}/user-roles`);
  }

  getAttendStatus(clubID: number, userID: number) {
    return this.httpService.get(`${this.url}/attendance/${clubID}/${userID}`);
  }

  getAllMatchListByPlayerAndTeam(playerID: number, teamID: number) {
    return this.httpService.get(`${this.url}/get-all-match-list-by-player-and-team/${playerID}/${teamID}`);
  }

  getPlayerStatisticsGameList(playerID: number, teamID: number) {
    return this.httpService.get(`${this.url}/get-player-statistics-game-list/${playerID}/${teamID}`);
  }

  getPlayerTeamsByClub(playerID: number, clubID: number) {
    return this.httpService.get(`${this.url}/get-player-teams-by-club/${playerID}/${clubID}`);
  }
  updatePlayerForm(data: any) {
    return this.httpService.post(`${this.url}/update-player-form`, data);
  }

  removeFilesFromS3(files: string[]) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      }),
      body: {
        playerFormPathList: files
      }
    };
    return this.http.delete(this.url + '/removeFilesFromS3', httpOptions);
  }

  //[HttpPost("save-or-update-player-safe-sport-training-info")]
  saveOrUpdatePlayerSafeSportTrainingInfo(payload: any) {
    return this.httpService.post(`${this.url}/save-or-update-player-safe-sport-training-info`, payload);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/player.service.ts